<template>
  <div class="text-textColor">
    <transition name="fade">
      <div v-if="loading">
        <Loader />
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="showEditAnnouncemnt"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <div
          class="fixed h-screen center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full"
        >
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Edit Announcemnt</p>
            <img
              v-if="!loading"
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <form @submit.prevent="edit" class="h-screen overflow-auto">
            <transition name="fade">
              <div
                v-if="create_error"
                class="p-1 text-center text-sm w-full bg-yellow-200"
              >
                {{ create_error }}
              </div>
            </transition>
            <transition name="fade">
              <div
                v-if="create_success"
                class="p-1 text-center text-sm w-full bg-green-200"
              >
                {{ create_success }}
              </div>
            </transition>
            <div class="grid grid-cols-1 p-4 gap-2">
              <!-- {{ info }} -->
              <div class="text-sm">
                <label class="block pb-1">Title</label>
                <input
                  v-model="info.Title"
                  type="text"
                  class="p-2 bg-gray-200 rounded-full w-full"
                  placeholder="New System Training"
                  required
                />
              </div>
              <div class="span">
                <label>Announcement</label>
                <textarea
                  v-model="info.Content"
                  class="p-2 bg-gray-200 rounded-xl w-full"
                  rows="5"
                  required
                ></textarea>
              </div>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 p-4 gap-3">
              <div class="text-sm">
                <label class="block pb-1">Visibility</label>
                {{ info.Visibility }}
                <el-select
                  filterable
                  class="bg-gray-200 rounded-full w-full border-none"
                  v-model="info.Visibility"
                  :required="info.Status == 2"
                  placeholder="Select a type"
                >
                  <el-option
                    v-for="visibility in visibilities"
                    :key="visibility.visibility"
                    :label="visibility.visibility"
                    :value="visibility.value"
                  >
                  </el-option>
                </el-select>

                <el-select
                  filterable
                  class="bg-gray-200 rounded-full w-full border-none"
                  v-model="info.DepartmentId"
                  v-if="info.Visi == 2"
                  placeholder="Select a type"
                >
                  <el-option
                    v-for="department in departments"
                    :key="department.DepartmentId"
                    :label="department.Name"
                    :value="department.DepartmentId"
                  >
                  </el-option>
                </el-select>
              </div>

              <div class="text-sm" v-if="info.Visibility == 2">
                <label class="block pb-1">Department</label>

                <el-select
                  filterable
                  class="bg-gray-200 rounded-full w-full border-none"
                  v-model="info.DepartmentId"
                  placeholder="Select a type"
                >
                  <el-option
                    v-for="department in departments"
                    :key="department.DepartmentId"
                    :label="department.Name"
                    :value="department.DepartmentId"
                  >
                  </el-option>
                </el-select>
              </div>

              <div class="text-sm">
                <label class="block pb-1">Publication Date</label>

                <el-date-picker
                  v-model="info.PublicationDate"
                  type="date"
                  class="w-full"
                  placeholder=""
                  style="width: 100% !important"
                >
                </el-date-picker>
              </div>
              <div class="text-sm">
                <label class="block pb-1">Expiration Date</label>

                <el-date-picker
                  v-model="info.ExpirationDate"
                  type="date"
                  placeholder=""
                  style="width: 100% !important"
                >
                </el-date-picker>
              </div>

              <div class="text-sm">
                <label class="block pb-1">Status</label>

                <el-select
                  filterable
                  class="bg-gray-200 rounded-full w-full border-none"
                  v-model="info.Status"
                  placeholder="Select a type"
                >
                  <el-option
                    v-for="status in statuses"
                    :key="status.status"
                    :label="status.status"
                    :value="status.value"
                  >
                  </el-option>
                </el-select>
              </div>

              <div class="text-sm">
                <label class="block pb-1">Priority</label>
                <el-select
                  filterable
                  class="bg-gray-200 rounded-full w-full border-none"
                  v-model="info.Priority"
                  placeholder="Select a type"
                >
                  <el-option
                    v-for="priority in priorities"
                    :key="priority.priority"
                    :label="priority.priority"
                    :value="priority.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="flex justify-end p-5">
              <button
                type="submit"
                class="bg-primary rounded-full px-10 text-sm text-white py-2"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "../loader/loader.vue";
export default {
  name: "AddAnnouncemnt",
  props: ["showEditAnnouncemnt", "reload", "info"],
  components: { Loader },
  data() {
    return {
      loading: false,
      create_error: null,
      create_success: null,
      departments: [],
      statuses: [
        { status: "Draft", value: 0 },
        { status: "Published", value: 1 },
        { status: "Archived", value: 2 },
      ],

      priorities: [
        { priority: "Low", value: 0 },
        { priority: "Medium", value: 1 },
        { priority: "High", value: 2 },
      ],

      visibilities: [
        { visibility: "Public", value: 1 },
        { visibility: "Department", value: 2 },
      ],
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  created() {
    this.getDepartments();
  },
  methods: {
    // /{organization}/announcement/v1/edit
    close() {
      this.$emit("close");
    },
    async edit() {
      const url = `${this.getOrganization}/announcement/v1/edit`;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      // Define a helper function to convert a textual value to its numeric equivalent
      const convertToNumber = (value, array) => {
        const match = array.find(
          (item) =>
            item.status === value ||
            item.priority === value ||
            item.visibility === value
        );
        return match ? match.value : value; // If no match is found, keep the original value
      };

      try {
        this.info["AnnouncementId"] = this.info.Id;

        // Convert textual values to numeric format if necessary
        this.info.Visibility = isNaN(this.info.Visibility)
          ? convertToNumber(this.info.Visibility, this.visibilities)
          : this.info.Visibility;
        this.info.Status = isNaN(this.info.Status)
          ? convertToNumber(this.info.Status, this.statuses)
          : this.info.Status;
        this.info.Priority = isNaN(this.info.Priority)
          ? convertToNumber(this.info.Priority, this.priorities)
          : this.info.Priority;

        const response = await axios.put(url, this.info, options);
        if (response.data.StatusCode === 200) {
          this.create_success = response.data.StatusMessage;

          setTimeout(() => {
            this.$emit("close");
            this.reload();
            this.create_success = null;
          }, 3000);
        } else {
          this.create_error = response.data.StatusMessage;
          setTimeout(() => {
            this.create_error = null;
          }, 3000);
        }
      } catch (error) {
        this.create_error = null;

        setTimeout(() => {
          this.create_error = null;
        }, 3000);
      }
    },
    // /{organization}/setup/department/v1/request
    getDepartments() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/department/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              //console.log(response.data.Data);
              this.departments = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
